<template>
<div>
  <div v-if="testappUse"><div :is="testappRoot"></div></div>
  <div class="payout">

    <WaitMessage :ob="claimob" />

    <div v-if="claimob.claim">

      <div class="claimob">
        <div class="claimob-dl claimob-1">
          <div class="claimob-dt">Номер заявки</div>
          <div class="claimob-dd">
            <div class="num">№{{claimob.claim.num}}</div>
            <div class="small">{{claimob.claim.hint_country}}</div>
          </div>
        </div>
        <div class="claimob-dl claimob-2">
          <div class="claimob-dt">Название и № заявки туроператора</div>
          <div class="claimob-dd">
            {{claimob.claim.oper_avi_ins_name}}
            <br />{{claimob.claim.identifier}}
          </div>
        </div>
        <div class="claimob-dl claimob-3">
          <div class="claimob-dt">Туристы</div>
          <div class="claimob-dd">
            {{claimob.claim.tourist_short}}
          </div>
        </div>
        <div class="claimob-dl claimob-4">
          <div class="claimob-dt">Дата заезда</div>
          <div class="claimob-dd">
            <div>{{dmy(claimob.claim.datebeg)}}</div>
            <div class="small">{{numWord(claimob.claim.nights, ['ночь', 'ночи', 'ночей'])}}</div>
          </div>
        </div>
      </div>
      
    </div>

    <div><router-view :key="route.path" /></div>
  </div>
  <div class="versions">
    <a :href="gitlink" :title="gittitle" target="_blank">{{ver}}</a> <span :title="gate">gate</span>
  </div>
</div>
</template>

<style src="@/assets/styles/payout-styles-main.scss" lang="scss"></style>

<style lang="scss">
.claimob {
  max-width: 600px;
  display: flex;
  align-items: stretch;
  justify-content: stretch;
  border-collapse: collapse;
  font-size: 14px;

  box-shadow: 0 1px 3px -1px #aaa;
  transition: 0.2s ease;
  border-radius: 0 0 5px 5px;
  margin-bottom: 20px;


  &-dt {
    background: #3978ca;
    color: #fff;
    height: 70px;
    font-size: 14px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 10px 0 10px;
  }
  &-dd {
    display: flex;
    align-items: center;
    justify-content: center;
    align-items: stretch;
    flex-basis: 50%;
    flex-direction: column;
    padding: 10px;
  }
  &-dl {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }
  &-dl > div {border-right: 1px solid #e2e2e2;}
  &-dl:first-child >div {border-left: 1px solid #e2e2e2;}
  &-dd {border-bottom: 1px solid #e2e2e2;}

  .num {color: #f36d21; font-weight: bold;}
  .small {font-size: 11px; margin-top: 5px; color:#888;}


}
</style>

<style scoped lang="scss">
  .versions {
    text-align: right; 
    color:#999; font-size: 10px;
    a {
      color:#999; 
    }
  }
  .uplinks { 
    margin: 10px -10px 10px -10px;
    a {
      margin: 10px;
    }
  }
</style>

<script setup>
import {testappUse, testappRoot} from 'TESTAPP/testapp-payout.js'
import { PLAY_SERENITI } from '@/actions.js'
import {watch, ref, unref, computed, onMounted, reactive} from 'vue'
import { useRoute } from 'vue-router/composables'
import {getWithdrawalSummary} from '@/actions.js'
import dayjs from 'dayjs'
import {  numWord } from '@/util.js'
import '@/assets/styles/eto-main.scss' // чтобы стили не попадали в сборку дважды 

import WaitMessage from '@/comp/Payout/WaitMessage.vue'

const {date, commit, branch} = ETOBUILD
const gitlink = `https://git.eto.travel/amendelev/cruise/commits/branch/${branch}/search?q=${commit}`
const gittitle = `${date}; ${branch}`
const ver = commit.substr(0,7)
const gate = PLAY_SERENITI

const route = useRoute()

const props = defineProps({
  claim_num: String, 
})

const claimob = reactive({
  claim : null,
  reward: null,
  wait: true,
  message: '',
})

const dmy = (s) => {
  return dayjs(s).format('DD.MM.YY')
}

const load = () => {
    claimob.claim = null
    claimob.wait = true
    claimob.message = ''
    const {claim_num} = props

    getWithdrawalSummary({claim_num}).then( ({claim}) => {
      claimob.wait = false
      claimob.claim = claim
    }, message => {
      claimob.wait = false
      claimob.message = `Не удалось получить информацию по заявке ${claim_num}: ${message}`
    } )
}

load()

</script>
